import React from 'react';

import { StateManager } from '../state/StateManager';

export const MainContext = React.createContext(new StateManager());

export const MainContextProvider = ({ children }) => {
    return (
        <MainContext.Provider value={new StateManager()}>
            {children}
        </MainContext.Provider>
    );
};

export const useMainContext = () => React.useContext(MainContext);
